// extracted by mini-css-extract-plugin
export var chevron = "_dt-4";
export var chevronExpanded = "_dt-5";
export var row = "_dt-0";
export var rowBody = "_dt-6";
export var rowDescription = "_dt-7";
export var rowHeader = "_dt-1";
export var rowTitle = "_dt-2";
export var rowTitleComplete = "_dt-3";